import React from 'react'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import {about, experiences, getInTouch, leadership, mainBody, navBar, repos, skills} from './editable-stuff/config.js'
import MainBody from './components/home/MainBody'
import AboutMe from './components/home/AboutMe'
import Project from './components/home/Project'
import Footer from './components/Footer'
import Navbar from './components/Navbar'
import Skills from './components/home/Skills'
import GetInTouch from './components/home/GetInTouch.jsx'
import Leadership from './components/home/Leadership.jsx'
import Experience from './components/home/Experience'

const Home = React.forwardRef((props, ref) => {
        return (
            <>
                <MainBody
                    icons={mainBody.icons}
                    gradient={mainBody.gradientColors}
                    message={mainBody.message}
                    ref={ref}
                    title={`${mainBody.firstName} ${mainBody.middleName} ${mainBody.lastName} ${mainBody.secondLastName}`}
                />
                {
                    about.show && (
                        <AboutMe
                            heading={about.heading}
                            imgSize={about.imageSize}
                            link={about.imageLink}
                            message={about.message}
                            resume={about.resume}
                        />
                    )
                }
                {
                    experiences.show && (
                        <Experience experiences={experiences}/>
                    )
                }
                {
                    repos.show && (
                        <Project
                            heading={repos.heading}
                            length={repos.reposLength}
                            specfic={repos.specificRepos}
                            username={repos.gitHubUsername}
                        />
                    )
                }
                {
                    leadership.show && (
                        <Leadership
                            heading={leadership.heading}
                            img={leadership.images}
                            imageSize={leadership.imageSize}
                            message={leadership.message}
                        />
                    )
                }
                {
                    skills.show && (
                        <Skills
                            heading={skills.heading}
                            hardSkills={skills.hardSkills}
                            softSkills={skills.softSkills}
                        />
                    )
                }
            </>
        )
    }
)

const App = () => {
    const titleRef = React.useRef()

    return (
        <BrowserRouter>
            {navBar.show && <Navbar ref={titleRef}/>}
            <Routes>
                <Route path="/" exact element={<Home ref={titleRef}/>}/>
            </Routes>
            <Footer>
                {
                    getInTouch.show && (
                        <GetInTouch
                            email={getInTouch.email}
                            heading={getInTouch.heading}
                            message={getInTouch.message}
                        />
                    )
                }
            </Footer>
        </BrowserRouter>
    )
}

export default App